import { proxy } from 'valtio';
import { getCurrentRouteSearchParams } from '@/shared/lib/route-search-params';

const DEFAULT_PROJECT_TITLE = '';

interface ProjectStore {
  projectId: string;
  projectTitle: string;
  projectCover: string;
  teamId: string;
  shareId: string;
  communityId: string;
  hashParams: URLSearchParams | null;
  expiredTime: number;
}

const getInitialProjectId = () => {
  return getCurrentRouteSearchParams().get('id') ?? '';
};

const initialProjectId = getInitialProjectId();

export const projectStore = proxy<ProjectStore>({
  projectId: initialProjectId,
  projectTitle: DEFAULT_PROJECT_TITLE,
  projectCover: '',
  teamId: '',
  hashParams: null,
  shareId: '',
  communityId: '',
  expiredTime: 0,
});

export const setProjectId = (id: string) => {
  if (projectStore.projectId === id) {
    return;
  }

  projectStore.projectId = id;
  projectStore.projectTitle = DEFAULT_PROJECT_TITLE;
  projectStore.projectCover = '';
};

export const setProjectTeamId = (teamId: string) => {
  projectStore.teamId = teamId;
};

export const setProjectExpiredTime = (expiredTime: number) => {
  projectStore.expiredTime = expiredTime;
};

export const getProjectIsExpired = () => {
  if (!projectStore.teamId) {
    return false;
  }
  return projectStore.expiredTime > 0 && Math.floor(Date.now() / 1000) > projectStore.expiredTime;
};

export const setHashParams = (hashParams: URLSearchParams) => {
  if (!hashParams || hashParams.toString() === projectStore.hashParams?.toString()) {
    return;
  }
  const urlProjectId = hashParams.get('id') ?? "";
  setProjectId(urlProjectId);

  const shareId = hashParams.get('shareId') ?? "";
  if (shareId && shareId !== projectStore.shareId) {
    projectStore.shareId = shareId;
  }

  const communityId = hashParams.get('communityId') ?? "";
  if (communityId && communityId !== projectStore.communityId) {
    projectStore.communityId = communityId;
  }

  projectStore.hashParams = hashParams;
};

export const setProjectTitle = (title: string) => {
  const nextTitle = title.trim() || DEFAULT_PROJECT_TITLE;

  projectStore.projectTitle = nextTitle;
};

export const setProjectCover = (cover: string) => {
  const nextCover = cover.trim();

  if (projectStore.projectCover === nextCover) {
    return;
  }

  projectStore.projectCover = nextCover;
};
